import React from 'react'
import { Skeleton } from '../../../Skeleton'

interface TagsProps {
  tags?: Array<string>
  onTagClick: (tag: string) => void
}

export const Tags: React.FC<TagsProps> = ({ tags, onTagClick }) => {
  if (!tags) {
    return (
      <div className="flex flex-wrap gap-2">
        {new Array(5).fill(undefined).map((_, index) => (
          <Skeleton key={index} className="w-20 h-8 rounded-md" />
        ))}
      </div>
    )
  }

  if (tags.length === 0) {
    return (
      <p className="text-sm text-gray-500">Brak tagów</p>
    )
  }

  return (
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <button
          key={tag}
          onClick={() => onTagClick(tag)}
          className="inline-flex items-center rounded-md bg-gray-100 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-200 transition-colors"
        >
          {tag}
        </button>
      ))}
    </div>
  )
}
